import {makeAutoObservable, runInAction} from "mobx";
import {sessionAPI} from "@services/session/api";
import {socketStore} from "@services/socket";

type Session = {
    id: string
    email: string
    nickname: string
    role: "admin" | "user" | null
    exp: number
    iat: number
}

class SessionStore {
    prevIsAuth = false

    authId = null
    email = null
    nickname = null
    role = null
    isAuth = false

    constructor() {
        makeAutoObservable(this)
    }

    get socketStore() {
        return socketStore
    }


    setAuthData = (authData, isAuth) => {
        runInAction(() => {
            this.authId = authData.id;
            this.email = authData.email;
            this.nickname = authData.nickname
            this.role = authData.role
            this.isAuth = isAuth
        })

    }

    getAuthMe = async () => {
        try {
            const data = await sessionAPI.authMe()
            console.log(data, 'getAuthMe')
            this.setSession(data)
            return data
        } catch (e) {
            this.clearSession()
            console.log('error',e)
        }
    }

    setSession = (user) => {
        runInAction(() => {

            this.authId = user.id;
            this.nickname = user.nickname
            this.role = user.role
            this.isAuth = true

        })
        this.socketStore.reconnectSocket()
        const timeout = setTimeout(() => {
            runInAction(() => {
                this.prevIsAuth = true
            })
            clearTimeout(timeout)
        })
        // socket.disconnect().connect()
    }

    clearSession = () => {
        runInAction(() => {
            this.prevIsAuth = false
            this.authId = null;
            this.email = null;
            this.role = null
            this.isAuth = false
        })
        this.socketStore.reconnectSocket()
        // socket.disconnect().connect()
    }

    // setSession = async (user) => {
    //     if (!user) this.closeSession()
    //
    //     this.setSession(user)
    //     socket.disconnect().connect()
    // };

    logout = async () => {
        try {
            const data = await sessionAPI.logout()
            this.clearSession()
            // socket.disconnect().connect()
        } catch (err) {
            console.log(err)
        }
    };

}

export const sessionStore: SessionStore = new SessionStore()